import styled from '@emotion/styled';
import LevelTitle from '@/components/RubricsPortfolioComponents/StyledLevel/LevelTitle';

const ButtonLabel = styled(LevelTitle)({
  marginBottom: 0,
  fontSize: 18,
});

export default ButtonLabel;
